// MobileRail — trilho horizontal touch. Parede A3.
//
// Substituto mobile das rails da TV (que navegam por ←/→ com auto-center do
// item focado). Aqui é SCROLL HORIZONTAL NATIVO: overflow-x:auto + momentum
// (-webkit-overflow-scrolling) + scroll-snap suave. Sem botões ‹ ›, sem foco.
//
// É um componente "burro" de layout: recebe título e os cards já montados.

import type { ReactNode } from 'react'

import styles from './MobileRail.module.css'

export interface MobileRailProps {
  title: ReactNode
  /** Cards já renderizados (MobileVodCard, etc). */
  children: ReactNode
  /** data-rail pra os testes localizarem cada trilho. */
  railId: string
}

export function MobileRail({ title, children, railId }: MobileRailProps): JSX.Element {
  return (
    <section className={styles.rail} data-rail={railId}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.track}>{children}</div>
    </section>
  )
}
